export class GmonResults {
    public gridElement_id: number;
    public dso_internal_id: string;
    public type: string;
    public maxVoltage: number;
    public minVoltage: number;
    public maxVoltageTimestamp: string;
    public minVoltageTimestamp: string;
    public numberOfUpperBoundViolation: number;
    public numberOfLowerBoundViolation: number;

    constructor(
        gridElement_id: number,
        dso_internal_id: string,
        type: string,
        maxVoltage: number,
        minVoltage: number,
        maxVoltageTimestamp: string,
        minVoltageTimestamp: string,
        numberOfUpperBoundViolation: number,
        numberOfLowerBoundViolation: number
    ) {
        this.gridElement_id = gridElement_id;
        this.dso_internal_id = dso_internal_id;
        this.type = type;
        this.maxVoltage = maxVoltage;
        this.minVoltage = minVoltage;
        this.maxVoltageTimestamp = maxVoltageTimestamp;
        this.minVoltageTimestamp = minVoltageTimestamp;
        this.numberOfUpperBoundViolation = numberOfUpperBoundViolation;
        this.numberOfLowerBoundViolation = numberOfLowerBoundViolation;
    }
}

export class GmonPlanningResults{
    public gridElement_id: number;
    public dso_internal_id: string;
    public type: string;
    public maxVoltage: number;
    public minVoltage: number;
    public scenarioId: string;
    public maxVoltageTimestamp: string;
    public minVoltageTimestamp: string;
    public numberOfUpperBoundViolation: number;
    public numberOfLowerBoundViolation: number;

    constructor(
        gridElement_id: number,
        dso_internal_id: string,
        type: string,
        maxVoltage: number,
        minVoltage: number,
        scenarioId: string,
        maxVoltageTimestamp: string,
        minVoltageTimestamp: string,
        numberOfUpperBoundViolation: number,
        numberOfLowerBoundViolation: number
    ) {
        this.gridElement_id = gridElement_id;
        this.dso_internal_id = dso_internal_id;
        this.type = type;
        this.maxVoltage = maxVoltage;
        this.minVoltage = minVoltage;
        this.scenarioId = scenarioId;
        this.maxVoltageTimestamp = maxVoltageTimestamp;
        this.minVoltageTimestamp = minVoltageTimestamp;
        this.numberOfUpperBoundViolation = numberOfUpperBoundViolation;
        this.numberOfLowerBoundViolation = numberOfLowerBoundViolation;
    }
}